import React, { useDebugValue, useEffect, useState } from 'react';
import { TouchableOpacity, Text, Image, View } from 'react-native';
import globalStyles from './styles/globalStyles';
import { formatDate } from '@/services/formatDate';
import { fetchPreviewImage } from '@/services/FetchFromAPI';
//import * as FileSystem from 'expo-file-system';
import { deleteFile } from '@/services/deleteEpaperFolder';

interface PDFListItemProps {
    index: number;
    date: string;
    edition: string;
    numberOfPages: number,
    pageInfo: Array<Object> | null,
    image?: any;
    filesize?: string;
    handleButtonPress: (date: string, edition: string, numberOfPages: number, pageInfo: Array<Object> | null) => void;
    handleDeleteButtonPress?: (date: string, edition: string) => void;
}

const getPreviewImage = async (date: string, edition: string): Promise<string> => {
    try {

        const articleImageData: any = await fetch(
            '/web-server-api/getImage',
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    "type": 'previewImage',
                    "date": date,
                    "edition": edition
                }),
            }
        );
    
        const data = await articleImageData.json();
        const imageBase64 = data.base64ImageStr;
        
        if(imageBase64) {
            return `${imageBase64}`;
        }
        else {
            return ''; // Maybe show in this case some dummy image?
        }

    } catch (error) {
        console.error(`Error fetching preview image for ${date}-${edition}:`, error);
        return '';        
    }
};

const PDFListItem: React.FC<PDFListItemProps> = ({
    index,
    date,
    edition,
    numberOfPages,
    pageInfo,
    image,
    filesize,
    handleButtonPress,
    handleDeleteButtonPress,
}) => {
    const [previewImage, setPreviewImage] = useState<string>('');
    const [imageDownloaded, setImageDownloaded] = useState<boolean>(false);

    useEffect(() => {
        const fetchPreview = async () => {
            const imagePath = await getPreviewImage(date, edition);
            setPreviewImage(imagePath);
            setImageDownloaded(true);
        };

        fetchPreview();
    }, [date, edition]);

    return (
        <View style={{ width: '45%', alignSelf: 'center', paddingVertical: 10, }}>
            <TouchableOpacity
                style={globalStyles.ePaperSelectorButton}
                key={index}
                onPress={() => handleButtonPress(date, edition, numberOfPages, pageInfo)}
            >
                <Text style={globalStyles.ePaperSelectorinfo}>{formatDate(date)} - {edition}</Text>
                {previewImage && (
                    <Image source={{ uri: previewImage }} style={globalStyles.ePaperSelectorImage} />
                    /*<Image source={{ uri: previewImage }} style={globalStyles.ePaperSelectorImage} />*/
                )}

                {filesize && (
                    <Text style={globalStyles.ePaperSelectorinfoSmall}>Dateigröße: {filesize} MB</Text>
                )}
                {/*handleDeleteButtonPress && (
                    <TouchableOpacity
                        style={globalStyles.ePaperSelectorDeleteButton}
                        onPress={() => handleDeleteButtonPress(date, edition)}
                    >
                        <Text style={globalStyles.ePaperSelectorDeleteButtonText}>Ausgabe lokal löschen</Text>
                    </TouchableOpacity>
                )*/}
            </TouchableOpacity>
        </View>
    );
};

export default PDFListItem;